import { Entity } from "./Entity";
/**
 * Presets for common UI elements.
 */
export class InterfaceColors extends Entity {
}
InterfaceColors.className = "InterfaceColors";
InterfaceColors.classNames = Entity.classNames.concat([InterfaceColors.className]);
//# sourceMappingURL=InterfaceColors.js.map